import { writable } from 'svelte/store';
const urlStore = writable(parse(window.location.hash));
/**
 * Break a URL fragment in GET-like format #x=y&z=w into an object.
 */
function parse(fragment) {
    if (fragment.startsWith('#')) {
        fragment = fragment.substring(1);
    }
    const result = fragment.split('&').reduce((result, pair) => {
        if (pair.includes('=')) {
            const [key, value] = pair.split('=');
            result[key] = decodeURIComponent(value);
        }
        return result;
    }, {});
    if (!result['tab']) {
        result['tab'] = 'menu';
    }
    return result;
}
/**
 * Stringify an object into a URL fragment.
 */
function stringify(params) {
    return Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
}
/**
 * Set up an event listener to update the store when the URL fragment changes.
 */
window.addEventListener('hashchange', () => {
    urlStore.set(parse(window.location.hash));
});
/**
 * Set a key in the URL fragment.
 */
function setUrlKey(key, value) {
    const obj = parse(window.location.hash);
    if (value === undefined || value === null) {
        delete obj[key];
    }
    else {
        obj[key] = value;
    }
    window.location.hash = stringify(obj);
}
/**
 * Set a bunch of keys in the URL fragment.
 */
function setUrlKeys(updates) {
    const obj = parse(window.location.hash);
    for (const [key, value] of Object.entries(updates)) {
        if (value === null) {
            delete obj[key];
        }
        else {
            obj[key] = value;
        }
    }
    window.location.hash = stringify(obj);
}
/**
 * Set the full URL fragment.
 */
function setUrl(params) {
    window.location.hash = stringify(params);
}
export const urlFragment = {
    subscribe: urlStore.subscribe,
    setUrlKey,
    setUrlKeys,
    setUrl,
};
